import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import swal from 'sweetalert';
import RaisedButton from 'material-ui/RaisedButton';

var Config = require('../../../config');

class UnitReturn extends Component{
	constructor(props){
		super(props);

		
		this.getUnits = this.getUnits.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.getDestiny = this.getDestiny.bind(this);
		this.getDiscardReasons = this.getDiscardReasons.bind(this);
		this.getReturnReason = this.getReturnReason.bind(this);

		this.state = {
			group:"",
			rh:"",
			patient:"",
			no_file:"",
			group_rh:"",
			table_units:[],
			petition_id:"",
			reasons:[],
			center_sent:"",
			destinations:[],
			show_discard:true,
			discards:[],
			from_hemo:false,
		}
	}

	componentDidMount(){
		this.getUnits();
		this.getReturnReason();
		this.getDiscardReasons();
		this.getDestiny();
	}

	getDestiny(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'lookups/order_by?type=return_destination&option=name',{
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	:'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({destinations:response});
			}
		})
	}

	getDiscardReasons(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'discard_reasons?option=return_units', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.setState({discards:response});
			}
		});
	}

	getReturnReason(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'lookups?type=refound_petiton_reasons&option=actives&order=true', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.setState({reasons:response});
			}
		});
	}

	getUnits(){
		var id = this.props.match.params.id;
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'unit_delivered/by_petition?id='+id+
			'&hf_id='+sessionStorage.getItem('health_facilities_id'), {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.setState({
					group:response.patient_group,
					rh:response.patient_rh,
					patient:response.patient_name,
					no_file: response.expedient,
					group_rh: response.patient_group+
						(response.patient_rh === 'POSITIVO' ?
							'+'
						:response.patient_rh === 'NEGATIVO' ?
							'-'
						: ''),
					table_units:[],
					center_sent:response.center_sent,
					from_hemo: response.from_hemo
				});

				response.units_delivered.map((res, i)=>{
					
					this.setState({
						table_units: [
							...this.state.table_units,
							{
								folio:res.folio,
								unit_id:res.unit.id,
								unit: res.unit.unit_number,
								component: res.component,
								component_number: res.unit.component_number,
								received_by: res.received_by,
								facility_sections_name: res.facility_sections_name,
								id:res.unit_delivered_id,
								check:false,
								reason:"",
								destination:response.from_hemo ? "RETURN_WAREHOUSE" : "",
								discard:"",
								disabled: res.refund_date !== null ? false : res.can_refund,
								refund_date: res.refund_date,
								volume: res.unit.volume
							}
						],
					});
				})

				this.setState({petition_id:id});		
			}
		});
	}

	onReturn(){
		this.props.history.goBack();
		//this.props.history.push('/petition_register');
	}

	handleChange(e, type){
		var campo = e.target.id.split('_')[0];
		var id = parseInt(e.target.id.split('_')[1]);
		var index = this.state.table_units.findIndex(obj => 
			obj.id === id
		)

		if(campo === 'check'){
			this.state.table_units[index].check = e.target.checked ? true : false;

			if(!e.target.checked){
				const select = document.querySelector('form');
				const inputs = select.querySelectorAll('input, select');
				inputs.forEach(input => {
			    	if(input.required){
				      	var control = document.getElementById(input.id);
				      	if(control.required && control.className.includes('error')){
							control.classList.remove('error');
						}
				  	}
			    });	
			}
				

		}else if(campo === 'reason'){
			this.state.table_units[index].reason = e.target.value;
		}else if(campo === 'destiny'){
			this.state.table_units[index].destination = e.target.value;
		}else if(campo === 'discard'){
			this.state.table_units[index].discard = e.target.value;
		}
			
		if(e.target.value !== ""){
			this.showCtrlError(e.target.id);
		}

		this.forceUpdate();


		setTimeout(()=>{
			var i_discard = this.state.table_units.findIndex(obj => obj.destination === 'discard');
			if(i_discard !== -1){
				this.setState({show_discard: false});
			}else{
				this.setState({show_discard: true});
			}
		}, 500);
	}

	onSave(){
		if(this.isValidForm()){
			var units = [];
			this.state.table_units.map((u)=>{
				if(u.check){
					units.push({
						unit_delivery_id:u.id,
						return_reason: u.reason,
						return_destination: u.destination,
						discard_reason_id: u.destination === 'discard' ? u.discard : ""
					});
				}
			})
			if(units.length > 0){
				this.props.waiting.handleShow('Guardando...');

				var apiUrl = this.state.from_hemo ? 'returns_delivery/from_hemo' : 'returns_delivery';

				fetch(Config.default.apiGateway.URL+apiUrl,{
					method:'POST',
					body: JSON.stringify(units),
					headers: new Headers({
						'Authorization'	:'Bearer '+sessionStorage.getItem('token'),
						'Accept'		:'application/json',
						'Content-Type'	:'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.props.history.push('/petition_register');
						swal('Buen Trabajo', 'Devolución Correcta', 'success');
					}
				})
			}else{
				swal('Error', 'Debe seleccioar al menos una unidad', 'error');
			}
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}
		
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showCtrlError(input.id);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if(control !== null){
			if (control.value === "") {		
				control.classList.add('error');
				res = false;
			}else{
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
				res = true;
			}
			
		}
		
		return res;
	}

	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');
		return(

			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
						Devolución de Unidades
					</h5>
				</div>
				<form noValidate>
					<fieldset className="col-xs-12 form-group">
						<legend>Datos generales</legend>

						<div className="col-xs-12">
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Número de Expediente</span>
							</div>
							<div className="col-xs-12 col-sm-9">
								<span className="color-font">{this.state.no_file}</span>
							</div>
						</div>
						<div className="col-xs-12">
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right", marginTop:"10px"}}>
								<span className="span-min">Nombre de Paciente</span>
							</div>
							<div className="col-xs-12 col-sm-6">
								<span className="patient-name" style={{marginRight:"20px"}}>{this.state.patient}</span>

								<span style={{color:"red", fontWeight:"bold", fontSize:"25px"}}>{this.state.group_rh}</span>
							</div>
						</div>
						<div className="col-xs-12 form-group">
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
								<span className="span-min">Hospital</span>
							</div>
							<div className="col-xs-12 col-sm-9">
								<span className="color-font">{this.state.center_sent}</span>
							</div>
						</div>
					</fieldset>
					<fieldset className="col-xs-12">
						<legend>Detalles del envío</legend>

						<Table responsive hover>
							<thead>
								<tr>
									<th></th>
									<th>Folio</th>
									<th>Unidad</th>
									<th>Componente</th>
									<th>Numero Componente</th>
									<th>Volumen</th>
									<th>Entregado a</th>
									<th>Destino</th>
									<th>Motivo Devolución</th>
									<th>Destino Devolución</th>
									<th hidden={this.state.show_discard}>
										Motivo de Baja
									</th>
								</tr>
							</thead>
							<tbody>
								{this.state.table_units.map((t, i)=>(
									<tr key={i}>
										<td>
											<input type="checkbox" id={'check_'+t.id} 
												checked={t.check} 
												disabled={!t.disabled}
												onChange={this.handleChange}/>
										</td>
										<td>{t.folio}</td>
										<td>{t.unit}</td>
										<td>{t.component}</td>
										<td>{t.component_number}</td>
										<td>{t.volume}</td>
										<td>{t.received_by}</td>
										<td>{t.facility_sections_name}</td>
										<td>
											{t.refund_date === null &&
												<select className="form-control" id={'reason_'+t.id} 
													value={t.reason} onChange={this.handleChange}
													required={t.check}
													disabled={!t.disabled}>
													<option value="">Seleccione...</option>
													{this.state.reasons.map((r, j)=>(
														<option key={j} value={r.key}>
															{r.name}
														</option>
													))}
												</select>
											}
										</td>
										<td>
											{t.refund_date === null ?
												<select className="form-control" id={'destiny_'+t.id} 
													value={t.destination} onChange={this.handleChange}
													required={t.check}
													disabled={this.state.from_hemo}>
													<option value="">Seleccione...</option>
													{this.state.destinations.map((d, j)=>(
														<option key={j} value={d.key}>
															{d.name}
														</option>
													))}
												</select>

											: 'Unidad devuelta'}
												
										</td>
										<td hidden={this.state.show_discard}>
											{t.destination === 'discard' ?
												<select className="form-control" id={'discard_'+t.id} 
													value={t.discard} onChange={this.handleChange}
													required={t.check}>
													<option value="">Seleccione...</option>
													{this.state.discards.map((d, j)=>(
														<option key={j} value={d.id}>
															{d.name}
														</option>
													))}
												</select>
											:null}
												
										</td>
										
									</tr>
								))}
									
							</tbody>
						</Table>
					</fieldset>
				</form>

				<div className="col-xs-12" style={{textAlign:'center'}}>	 
					<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave} style={{margin:12}}/>
	        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} onClick={this.onReturn} style={{margin:12}}/>
				</div>
			</div>
		)
	}
}

export default translate('translations') (UnitReturn)